const navigationTabs = {
    dashboard: {
        seller: "seller",
        buyer: "buyer",
    },
    seller: {
        debtors: {
            overview: "overview"
        },
        marketSounding: {
            start: "start",
            prospective: "prospective",
            prospectiveHistory: "prospectiveHistory",
        },
        sell: {
            upload: "upload",
            new: "new",
            waiting: "waiting",
            rejected: "rejected",
            approved: "approved",
            selling: "selling",
        },
        putOptions: {
            requests: "requests",
            active: "active",
            contracts: "contracts"
        },
        trackPay: {
            contracts: "contracts",
            settled: "settled",
        }
    },
    investor: {
        exchange: {
            receivables: "receivables",
            putOptions: "putOptions",
        },
        payments: {
            receivables: "receivables",
            putOptions: "putOptions",
        },
        investments: {
            receivables: "receivables",
            putOptions: "putOptions",
        },
        riskAssessment: {
            marketSoundingDecisions: "marketSoundingDecisions",
            customRatings: "customRatings",
            industryBlacklist: "industryBlacklist",
            debtor: "debtor",
            seller: "seller"
        }
    },
    debtor: {
        ipu: "ipu",
        trackPay: {
            contracts: "contracts"
        }
    },
    admin: {
        profile: {
            info: "info",
            apiKeys: "apiKeys"
        },
        company: {
            info: "info",
            cofaceToS: "cofaceToS",
            putOptionToS: "putOptionToS",
            tciActivation: "tciActivation"
        }
    }
};

export {
    navigationTabs
};